/* eslint-disable react/prop-types */
import React from "react";
import Tab from "@mui/material/Tab";
import TabsMui from "@mui/material/Tabs";

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const Tabs = ({ tab, setTab }) => {
  const handleChange = (event, newValue) => {
    setTab(newValue);
  };

  return (
    <div
      style={{
        position: "fixed",
        bottom: 0,
        left: 314,
        minWidth: 300,
        zIndex: 9999999,
        background: "#fff",
        border: "1px solid black",
      }}
    >
      <TabsMui value={tab} onChange={handleChange} aria-label="basic tabs example">
        <Tab sx={{ margin: "0px 4px" }} label="Tờ khai" {...a11yProps(0)} />
        <Tab sx={{ margin: "0px 4px" }} label="05-1/BK-TNCN" {...a11yProps(1)} />
        <Tab sx={{ margin: "0px 4px" }} label="05-2/BK-TNCN" {...a11yProps(2)} />
        <Tab sx={{ margin: "0px 4px" }} label="05-3/BK-TNCN" {...a11yProps(3)} />
      </TabsMui>
    </div>
  );
};

export default Tabs;
